import { useCallback, useEffect, useState } from 'react';
import api from './api';

/**
 * Hook que expone el snapshot de uso vs. cupo del plan de la organización activa.
 * Devuelve `null` mientras carga o si la org está en trial y aún no tiene cupo aplicable.
 */
export function useQuotaUsage() {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/plan/usage');
      setUsage(data);
    } catch (e) {
      setUsage(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { usage, loading, refresh };
}

export function pctOfQuota(row) {
  if (!row || row.max === null || row.max === undefined) return 0;
  if (row.max <= 0) return 0;
  return Math.min(100, Math.round((row.current / row.max) * 100));
}
